// Shop Revenue 조회 기간(period) 정의 — 셀렉트 옵션, 기간 시작 시각, 클라 필터.
//
// 모든 기간은 "오늘 포함 N 일" 의 로컬 자정 기준이다(롤링 N×24h 아님).
// 일별 추이 표가 날짜 버킷으로 묶이므로 자정 정렬이 맞고, DashboardPage 의 주간/월간 버킷
// (localMidnightMs(6) / (29)) 과도 같은 규칙이다.

export type Period = 'today' | '2d' | '7d' | '30d' | 'all';

export const PERIOD_OPTIONS: readonly { value: Period; label: string }[] = [
  { value: 'today', label: '오늘' },
  { value: '2d', label: '2일치' },
  { value: '7d', label: '7일치' },
  { value: '30d', label: '30일치' },
  { value: 'all', label: '전체' },
];

/** 오늘을 포함한 일수. 'all' 은 하한 없음. */
const PERIOD_DAYS: Record<Exclude<Period, 'all'>, number> = {
  today: 1,
  '2d': 2,
  '7d': 7,
  '30d': 30,
};

/** 넓이 순위 — 이미 불러온 기간보다 넓은 기간을 고르면 데이터가 부족해 재조회가 필요하다. */
const PERIOD_RANK: Record<Period, number> = { today: 0, '2d': 1, '7d': 2, '30d': 3, all: 4 };

/** 기간 시작 시각(로컬 자정 ms). 'all' 이면 null(하한 없음). now 는 테스트 주입용. */
export function periodStartMs(period: Period, now: Date = new Date()): number | null {
  if (period === 'all') return null;
  const d = new Date(now.getTime());
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - (PERIOD_DAYS[period] - 1));
  return d.getTime();
}

/** createdAt 이 기간 시작 이후인 레코드만. 파싱 불가한 createdAt 은 보수적으로 남긴다. */
export function filterByPeriod<T extends { createdAt: string }>(
  sales: T[],
  period: Period,
  now?: Date
): T[] {
  const from = periodStartMs(period, now);
  if (from == null) return sales;
  return sales.filter((s) => {
    const t = Date.parse(s.createdAt);
    if (Number.isNaN(t)) return true;
    return t >= from;
  });
}

/** next 가 loaded 보다 넓은 기간인가 (= 이미 받아둔 데이터로는 못 그림). */
export function isWiderPeriod(next: Period, loaded: Period): boolean {
  return PERIOD_RANK[next] > PERIOD_RANK[loaded];
}
